document.addEventListener("DOMContentLoaded", function() {
  // document.getElementsByClassName('tabs-panel').forEach(button => {
  let buttonList = document.getElementsByClassName("tabs-button");
  let tabList = document.getElementsByClassName("tabs-panel");

  for (let i = 0; i < buttonList.length; i++) {
    var button = buttonList.item(i);
    // listeners
    button.addEventListener("click", function(event) {
      event.preventDefault();
      click(i);
    });
    button.addEventListener("keydown", function(event) {
      if (event.key == "Enter") click(i);
    });
  }

  // actions
  function click(index) {
    var button = buttonList[index];
    var tab = tabList[index];

    // buttonstuff
    button.setAttribute("aria-selected", true);
    button.classList.add("is-active");

    //tabstuff
    tab.setAttribute("aria-hidden", false);
    tab.classList.add("is-active");

    // Number of buttons is equal to number of tabs
    for (let i = 0; i < buttonList.length; i++) {
      if (i == index) continue;
      buttonList[i].setAttribute("aria-selected", false);
      buttonList[i].classList.remove("is-active");
      tabList[i].setAttribute("aria-hidden", true);
      tabList[i].classList.remove("is-active");
    }
  }
});

// utils
function classRemove(element, removeName) {
  if (element.className.includes(removeName))
    return element.className.replace(removeName, "");
  return element.className;
}

function classAdd(element, addName) {
  if (element.className.includes(addName) == false)
    return element.className + " " + addName;
  return element.className;
}
